
import { PropType } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import tracking from '@/functions/tracking';
import BrokerAreaCard from '@/interfaces/brokerAreaCard.interface';

interface Data {
    uuid: string;
}

export default {
    props: {
        broker: {
            type: Object as PropType<BrokerAreaCard>,
            default: () => ({
                name: '',
                url: '',
            }),
        },
    },

    data(): Data {
        return {
            uuid: '',
        };
    },

    mounted(): void {
        this.uuid = `guid-${uuidv4()}`;
    },

    methods: {
        onClick(): void {
            tracking.track(
                'trackMaeglersoegning',
                'Maeglersoegning',
                'Maegler omraade klik',
                this.broker?.name ?? 'Ukendt omraade',
            );
        },
    },
};
